import { Button } from "rebass";

Button.defaultProps = {
  variant: "primary"
};

export default Button;
